import { makeStyles } from '@mui/styles';

/**
 * @remarks A make Styles element that allows for easy use of
 * css within Material UI components. Components import
 * this file and use these css classes.
 */
export const useStyles = makeStyles({
    container: {
        padding: '0 1rem 1rem 1rem',
        width: '100%',
    },
    title: {
        textAlign: 'center',
        padding: '0.25em',
    },
    dataContent: {
        display: 'flex',
        justifyContent: 'center',
        borderRadius: '0.25em',
        backgroundColor: '#cecece',
        marginBottom: '1rem',
    },
    resetButton: {
        margin: 'auto !important',
        display: 'block !important',
    },
    ml10: {
        marginLeft: '10px',
    },
    mt10: {
        marginTop: '10px',
    },
    actionFooter: {
        textAlign: 'center',
        marginTop: '10px',
    },
    formContainer: {
        margin: 'auto',
        padding: '1rem',
    },
    textCenter: {
        textAlign: 'center',
    },
    FormContainer: {
        padding: '20px',
    },
    btnWidth: {
        width: "auto"
    },
    buttonsContainer: {
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
        margin: '10px'
    },
    buttonsContainerMobileView: {
        flexDirection: "column",
        gap: "10px",
    },
    cardTitle: {
        margin: "0",
        fontSize: "2rem",
        color: "#1e88e5",
        marginBottom: "10px"
    },
    cardTitleMobileView: {
        fontSize: "1.5rem",
    },
    cardInfoText: {
        margin: "0",
        marginBottom: "10px",
        fontSize: "1rem",
        color: "#1e88e5",
        textAlign: "center"
    },
    textbox: {
        height: '10%',
        outline: 'none',
        id: "outlined-basic",
        boxSizing: 'border-box',
        padding: '1px 10px',
        transition: '0.2s ease-in-out',
        width: '100%',
    },
    //New Classes YEC
    wrapper: {
        marginTop: "0vh",
        paddingTop: "0vh",
        minHeight: "100vh",
    },
    supWrapper: {
        Margin: 1,
        paddingTop: '100px',
        padding: "1rem",
        minHeight: "100vh",
    },
    table: {
        '&:last-child td, &:last-child th': { border: 0 },
    },
    tableSpacing: {
        padding: "2vh",
    },
    tableGrid: {
        minWidth: "90%"
    },
    tableContainer: {
        height: '52vh'
    },
    tableBody: {
        overflow: 'auto',
        height: '100%'
    },
    tableNoResult: {
        padding: "20vh"
    },
    btnContainer: {
        minWidth: "15vh"
    },
    gridPadding: {
        paddingTop: '1vh',
        paddingLeft: "2vh",
        paddingRight: "2vh",
        paddingBottom: '3vh'
    },
    gridMargin: {
        marginLeft: 2,
        MarginRight: 2
    },
    gridPaddingTop: {
        paddingTop: "1rem"
    },
    list: {
        width: '100%',
        bgcolor: 'background.paper',
        position: 'relative',
        overflow: 'auto',
        maxHeight: '12vh',
        '& ul': { padding: 0 },
    },
    adList: {
        width: '100%',
        bgcolor: 'background.paper',
        position: 'relative',
        overflow: 'auto',
        maxHeight: '48vh',
        '& ul': { padding: 0 },
    },
    gridHeight: {
        height: "25%",
    },
    profileGrid: {
        minWidth: "40vh"
    },
    selectTopBotPadding: {
        paddingTop: "1vh",
        paddingBottom: "1vh"
    },
    paragraphWidth: {
        maxWidth: "30rem"
    },
    subWrapper2: {
        margin: "2rem",
        padding: "3rem",
    },
    subWrapper3: {
        marginTop: "5vh",
        marginBottom: "5vh",
    },
    fixGridMargin: {
        marginTop: "10vh"
    },
    gridLeftPadding: {
        paddingLeft: "10vh"
    },
    itemPadding: {
        paddingBottom: "5vh"
    },
    subWrapper4: {
        paddingBottom: "2vh"
    },
    tableHead: {
        '& .MuiTableCell-head': {
            fontWeight: 'bold',
        },
    },
    DataHead: {
        '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold',
        },
    },
    subWrapper5: {
        marginTop: "6rem",
        padding: "2rem",
    },
    buttonPadding: {
        paddingLeft: "2vh",
    },
    hoverClickable: {
        cursor: "pointer",
    },
    hoverNotClickable: {
        cursor: "default"
    },
    bannerTopPadding: {
        marginTop: '48px'
    },
    hoverableItem: {
        position: 'relative',
    },
    backdrop: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: 0,
        transition: 'opacity 0.3s ease',
    },
    hoverableItemHover: {
        '&:hover $backdrop': {
            opacity: 1,
        },
    },
    editButton: {
        backgroundColor: '#fff',
        border: 'none',
        borderRadius: '50%',
        padding: '1vh',
        cursor: 'pointer',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    },
    listItemSpacing: {
        margin: '1vh',
    },
    FABSpacing: {
        marginLeft: '1vh',
        MarginRight: '1vh'
    },
});


